var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"yin-yang-related-chart-group-wrapper",style:({
  '--related-chart-width': '400px'
})},[_c('yin-yang-related-chart-group',{attrs:{"site-data":_vm.dataList[0]}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d358aea","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/02Data-Audit/01Manual/AuditDeviceViews/YinYangRelatedChartGroupWrapper.vue
// module id = null
// module chunks = 